import React from "react";
import Home from './components/Home'
import Navbar from './components/Navbar'
import { BrowserRouter as Router, Routes , Route } from 'react-router-dom'
import About from './components/About'
import Contact from "./components/Contact";
import Footer from './components/Footer'
import Project from './components/Projects'
function App() {
  return (
    <Router>
    <Navbar/>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/about" element={<About/>} />
        <Route path='/contact' element={<Contact/>}/>
        <Route path="/project" element={<Project/>}/>
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
